import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import logo from "../../assets/images/logo-1.png";

const colors = {
  primary: "#D81919",
  secondary: "#990000",
  accent: "#FFEDED",
  dark: "#333333",
  light: "#FFFFFF",
  gray: "#F8F8F8",
};

const generateTransferInvoice = async (transfer) => {
  const invoiceDiv = document.createElement("div");
  invoiceDiv.style.padding = "10px";
  invoiceDiv.style.position = "absolute";
  invoiceDiv.style.left = "-9999px";
  invoiceDiv.style.background = "white";
  invoiceDiv.style.width = "900px"; // A4-like width

  const header = `
  <div style="display: flex; justify-content: space-between; margin-bottom: 40px; position: relative;">
    <div style="width: 66%; position: relative; overflow: hidden; height: 120px;">
      <div style="position: absolute; top: -20px; left: -200px; width: calc(100% + 220px); height: calc(100% + 40px); transform: skew(-15deg); z-index: 0; box-shadow: 0 3px 10px rgba(0,0,0,0.2);"></div>
      <img src="${logo}" alt="Logo" style="width: 85%; height: 100%; object-fit: contain; position: relative; z-index: 1; padding: 20px 20px 20px 40px;">
    </div>
    <div style="width: 32%; text-align: right; padding: 20px; background: ${colors.gray}; border-right: 5px solid ${colors.primary}; box-shadow: 0 3px 8px rgba(0,0,0,0.1);">
      <h2 style="margin-bottom: 15px; color: ${colors.primary}; font-size: 22px; font-weight: bold;">Contact Information</h2>
      <p style="margin: 5px 0; color: ${colors.dark};">Epar. Odos Mykonos 846 00</p>
      <p style="margin: 5px 0; color: ${colors.dark};">nleont@gmail.com</p>
      <p style="margin: 5px 0; color: ${colors.dark}; font-weight: bold;">+306941419012</p>
      <p style="margin: 5px 0; color: ${colors.primary};">${window.location.origin}</p>
    </div>
  </div>
  <div style="text-align: center; margin-bottom: 30px; padding: 10px 0; border-bottom: 2px solid ${colors.primary}; border-top: 2px solid ${colors.primary};">
    <h1 style="margin: 0; color: ${colors.primary}; font-size: 28px; text-transform: uppercase; letter-spacing: 2px;">PRE-INVOICE</h1>
    <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice #: TRF-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000000)}</p>
    <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice Date: ${new Date().toLocaleDateString("en-GB")}</p>
  </div>
  `;

  const infoSection = `
  <div style="display: flex; justify-content: space-between; margin-bottom: 40px; gap: 40px;">
    <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
      <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">CLIENT DETAILS</h3>
      <p style="margin: 10px 0; font-weight: bold; font-size: 16px;">${transfer.name} ${transfer.surname}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Phone:</span> ${transfer.phone}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Email:</span> ${transfer.email}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Passengers:</span> ${transfer.persons}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Luggage:</span> ${transfer.luggage}</p>
    </div>
    <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
      <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">TRANSFER INFORMATION</h3>
      <p style="margin: 10px 0; font-weight: bold; font-size: 16px;"><span style="color: ${colors.secondary}; font-weight: bold;">Vehicle Type:</span> ${transfer.carType.charAt(0).toUpperCase() + transfer.carType.slice(1)}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Service Type:</span> ${transfer.isReturn ? 'Round Trip' : 'One Way'}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Pick-up:</span> ${transfer.pickupLocation}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Drop-off:</span> ${transfer.dropoffLocation}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Date & Time:</span> ${new Date(transfer.pickUpDate).toLocaleDateString("en-GB")} at ${transfer.pickupHours}:${transfer.pickupMinutes}</p>
      ${transfer.isReturn ? `<p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Return:</span> ${new Date(transfer.returnDate).toLocaleDateString("en-GB")} at ${transfer.returnHours}:${transfer.returnMinutes}</p>` : ''}
    </div>
  </div>
`;

  // Create price rows based on service type
  const priceRows = [];
  
  // One-way transfer price row
  priceRows.push(`
    <tr style="background-color: ${colors.light};">
      <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
        Transfer from ${transfer.pickupLocation} to ${transfer.dropoffLocation}
        (${new Date(transfer.pickUpDate).toLocaleDateString("en-GB")})
      </td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€${(transfer.priceTotal / (transfer.isReturn ? 2 : 1)).toFixed(2)}</td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">1</td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${(transfer.priceTotal / (transfer.isReturn ? 2 : 1)).toFixed(2)}</td>
    </tr>
  `);
  
  // Return trip price row (if applicable)
  if (transfer.isReturn) {
    priceRows.push(`
      <tr style="background-color: ${colors.accent};">
        <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
          Return transfer from ${transfer.dropoffLocation} to ${transfer.pickupLocation}
          (${new Date(transfer.returnDate).toLocaleDateString("en-GB")})
        </td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€${(transfer.priceTotal / 2).toFixed(2)}</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">1</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${(transfer.priceTotal / 2).toFixed(2)}</td>
      </tr>
    `);
  }
  
  // Additional options
  const additionalOptionsRows = [];
  if (transfer.atDisposal && transfer.disposalHours) {
    additionalOptionsRows.push(`
      <tr style="background-color: ${colors.light};">
        <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
          Driver at Disposal (${transfer.disposalHours} hour${parseInt(transfer.disposalHours) > 1 ? 's' : ''})
        </td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€20.00</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">${transfer.disposalHours}</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${(parseInt(transfer.disposalHours) * 20).toFixed(2)}</td>
      </tr>
    `);
  }
  
  if (transfer.helicopterTransfer) {
    additionalOptionsRows.push(`
      <tr style="background-color: ${colors.accent};">
        <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
          Helicopter Transfer (Price on Request)
        </td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">-</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">1</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">POA</td>
      </tr>
    `);
  }

  const priceTable = `
  <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 2px solid ${colors.primary}; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
    <thead>
      <tr style="background: ${colors.primary}; color: white;">
        <th style="padding: 15px; text-align: left; font-size: 15px;">Description</th>
        <th style="padding: 15px; text-align: center; font-size: 15px;">Rate</th>
        <th style="padding: 15px; text-align: center; font-size: 15px;">Quantity</th>
        <th style="padding: 15px; text-align: right; font-size: 15px;">Amount</th>
      </tr>
    </thead>
    <tbody>
      ${priceRows.join("")}
      ${additionalOptionsRows.join("")}
    </tbody>
  </table>
`;

  const additionalNotesSection = transfer.additionalInfo
    ? `
    <div style="margin-bottom: 20px; background: #f8f8f8; padding: 15px; border-left: 4px solid ${colors.primary}; border-radius: 4px;">
      <h4 style="margin-bottom: 10px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold;">Additional Notes</h4>
      <p style="margin: 0; font-style: italic;">${transfer.additionalInfo}</p>
    </div>
  `
    : "";

  // Calculate total price
  let totalPrice = transfer.priceTotal || 0;
  
  // Add disposal hours cost
  if (transfer.atDisposal && transfer.disposalHours) {
    totalPrice += parseInt(transfer.disposalHours) * 20;
  }
  
  // Calculate VAT (24%)
  const calculatedVat = totalPrice * 0.24;
  const calculatedSubtotal = totalPrice - calculatedVat;

  const totalsSection = `
  <div style="display: flex; justify-content: flex-end;">
    <div style="width: 350px;">
      <div style="border: 2px solid ${colors.primary}; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
        <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${colors.accent};">
          <div style="display: flex; justify-content: space-between;">
            <span style="font-weight: bold;">Subtotal:</span>
            <span>€${calculatedSubtotal.toFixed(2)}</span>
          </div>
        </div>
        <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${colors.accent};">
          <div style="display: flex; justify-content: space-between;">
            <span style="font-weight: bold;">VAT (24%):</span>
            <span>€${calculatedVat.toFixed(2)}</span>
          </div>
        </div>
        <div style="padding: 16px; background: ${colors.primary}; color: white;">
          <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 18px;">
            <span>TOTAL:</span>
            <span>€${totalPrice.toFixed(2)} (NOT PAID)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
  const footer = `
  <div style="margin-top: 50px;">
    <div style="margin-bottom: 30px; padding: 20px; background: ${colors.accent}; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
      <p style="margin: 0; font-style: italic; color: ${colors.dark};">Thank you for choosing <span style="font-weight: bold; color: ${colors.primary};">Luxury Car Mykonos Transfer</span>. For assistance, contact us at <span style="font-weight: bold;">+306941419012</span> or <span style="font-weight: bold;">nleont@gmail.com</span></p>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 30px;">
      <div style="width: 30%;">
        <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
        <div style="background: ${colors.primary}; height: 2px;"></div>
      </div>
      <div style="width: 200px; text-align: center;">
        <div style="border-bottom: 2px solid ${colors.primary}; margin-bottom: 8px; padding-bottom: 15px;">
          </div>
        <p style="margin: 0; font-weight: bold; color: ${colors.primary};">Nikos Leontitsis</p>
        <p style="margin: 0; color: ${colors.dark};">Managing Director</p>
      </div>
      <div style="width: 30%;">
        <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
        <div style="background: ${colors.primary}; height: 2px;"></div>
      </div>
    </div>
  </div>
  <div style="margin-top: 40px; text-align: center; padding-top: 20px; border-top: 2px dashed ${colors.accent};">
  </div>
`;

  invoiceDiv.innerHTML =
    header +
    infoSection +
    priceTable +
    additionalNotesSection +
    totalsSection +
    footer;
  document.body.appendChild(invoiceDiv);

  try {
    const scale = 2;
    const canvas = await html2canvas(invoiceDiv, {
      scale: scale,
      logging: false,
      useCORS: true,
      allowTaint: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF("p", "pt", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgX = (pdfWidth - imgWidth * ratio) / 2; // Center the image
    const imgY = 20; // Small top margin

    pdf.addImage(
      imgData,
      "JPEG",
      imgX,
      imgY,
      imgWidth * ratio,
      imgHeight * ratio
    );

    // Add page numbers (if needed, currently single page)
    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.setTextColor(150);
    }    const pdfData = pdf.output("datauristring");
    const base64Data = pdfData.split(",")[1]; // Return base64 data
    
    // Verify the data before returning
    if (!base64Data) {
      console.error("PDF generation failed - no base64 data produced");
      throw new Error("PDF generation failed");
    }
    
    console.log(`PDF generated successfully: ${Math.round((base64Data.length * 3/4) / 1024)}KB`);
    return base64Data;
  } finally {
    // Clean up the temporary DOM element
    if (document.body.contains(invoiceDiv)) {
      document.body.removeChild(invoiceDiv);
    }
  }
};

export default generateTransferInvoice;
